import React from 'react';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const EditButton = ({ label, ...props }) => {
  return (
    <Button
      key="edit"
      type="primary"
      {...props}
      style={{ marginRight: '16px' }}
    >
      <EditOutlined />
      {label}
    </Button>
  );
};

EditButton.defaultProps = {
  label: 'Edit',
};

EditButton.propTypes = {
  label: PropTypes.string.isRequired,
};

export default EditButton;
